// src/utils/apiConfig.js

// Get the environment from the REACT_APP_ENV variable or default to 'development'
const ENV = process.env.REACT_APP_ENV || 'development';

// Define API URLs for different environments
const API_URLS = {
  development: process.env.REACT_APP_DEV_API_URL || 'http://localhost:8000/api',
  production: process.env.REACT_APP_PROD_API_URL || 'https://signme-backend-92668879435.us-central1.run.app/api',
};

// Export the API URL for the current environment
export const API_URL = API_URLS[ENV];

console.log(`Using ${ENV} environment with API URL: ${API_URL}`);

export default API_URL;